import React from 'react';
import { UseComboboxReturnValue } from 'downshift';
import { EntityDTO, EntityTypeDTO } from '../../../../../../DocumentVault.meta';
import { Box } from '../../../../../../../CommonComponents/OPL/Box/Box';
import { Text } from '../../../../../../../CommonComponents/OPL/Text/Text';
import { EntitySearchResultsLoading } from './EntitySearchResults.loading';
import { Icon } from '../../../../../../../CommonComponents/OPL/Icon/Icon';
import { ENTITY_ICONS } from '../../../../../Entity/Entity.meta';
import { TruncatedText } from '../../../../../../../CommonComponents/OPL/Text/TruncatedText';
import { EntityListPopover, ListItem } from './EntitySearchResults.styles';

interface EntitySearchResultsProps {
  entityList?: EntityDTO[];
  isLoading: boolean;
  comboboxBag: UseComboboxReturnValue<EntityDTO>;
  searchTerm: string;
}

export const EntitySearchResults: React.FC<EntitySearchResultsProps> = ({
  isLoading,
  entityList,
  comboboxBag,
  searchTerm,
}) => {
  const { getMenuProps, isOpen } = comboboxBag;

  return (
    <EntityListPopover
      {...getMenuProps()}
      style={{ display: isOpen && searchTerm && (!!entityList || isLoading) ? 'block' : 'none' }}
    >
      <EntitySearchResultsContent
        isLoading={isLoading}
        entityList={entityList}
        comboboxBag={comboboxBag}
        searchTerm={searchTerm}
      />
    </EntityListPopover>
  );
};

const EntitySearchResultsContent: React.FC<EntitySearchResultsProps> = ({
  isLoading,
  entityList,
  comboboxBag: { getItemProps, highlightedIndex },
}) => {
  if (isLoading) {
    return (
      <Box px="16" py={6}>
        <EntitySearchResultsLoading />
      </Box>
    );
  }

  if (!entityList) {
    return null;
  }

  if (entityList?.length === 0) {
    return (
      <ListItem>
        <Text fontWeight={500} color="neutral.500">
          No results found
        </Text>
      </ListItem>
    );
  }

  const getDisplayPath = (entity: EntityDTO): string => {
    const trimmedPath = entity.path.replace(/\/+$/, '');
    const segments = trimmedPath.split('/').filter(Boolean);

    segments.pop();
    return segments.join(' > ');
  };

  return (
    <>
      {entityList.map((entity, index) => {
        const entityPath = getDisplayPath(entity);
        return (
          <ListItem
            isClickable
            key={index}
            {...getItemProps({ item: entity, index })}
            isHighlighted={highlightedIndex === index}
          >
            <Box display="flex" alignItems="baseline" flex={1}>
              <Icon className={ENTITY_ICONS[entity.type]} color="neutral.500" />
              <Box ml="8">
                <TruncatedText fontSize="h6" fontWeight={500}>
                  {entity.name}
                </TruncatedText>
                <TruncatedText fontSize="body" mt="4" color="neutral.500">{`Home ${entityPath &&
                  `> ${entityPath}`}`}</TruncatedText>
              </Box>
            </Box>
          </ListItem>
        );
      })}
    </>
  );
};
